import React, { useState } from 'react';

import { Copy, Modal } from '../../../components';
import ShortLinkForm from './components/ShortLinkForm';

import { ShortLinkGenerator } from './components/ShortLinkGenerator';
import { useShortLink } from '../hooks/useShortLink';
import { LongLinkGenerator } from './components/LongLinkgenerator';

type WebLinGeneratorProps = {
  agentId: string;
};

const WebLinkGenerator: React.FC<WebLinGeneratorProps> = ({ agentId }) => {
  const {
    isOpened,
    onOpen,
    onClose,
    formId: shortLinkId,
    shortLinkForm,
    setShortLinkForm,
    handleDeleteShortLink,
    handleCreateShortLink,
    handleCreatingShortLink,
    originalUrl,
    isMatched,
    setIsMatched,
    handleUpdatehortLink,
    agentData,
  } = useShortLink();

  const [longLinkData, setLongLinkData] = useState<{
    compressed: string;
    generatedLink: string;
  } | null>(null);

  const handleSaveLink = () => {
    const longLink = longLinkData?.generatedLink || (originalUrl ?? '');
    handleCreateShortLink({
      short_id: shortLinkForm.short_link_identifier,
      url: longLink,
    });
  };

  return (
    <>
      <Modal
        size="small"
        open={isOpened}
        onClose={onClose}
        title="Define short link"
      >
        <ShortLinkForm
          isDisabled={handleCreatingShortLink}
          formKey={String(shortLinkId || 'shortLinkForm')}
          onCancel={onClose}
          onSave={handleSaveLink}
          form={shortLinkForm}
          onChange={setShortLinkForm}
        />
      </Modal>
      <div className="flex flex-col gap-y-md">
        <div className="flex flex-col justify-end gap-x-md border border-border p-6 bg-white rounded-xl">
          <div className="flex flex-col gap-x-md">
            <div className="flex flex-row justify-end gap-x-md">
              <div className="text-small">Copy link</div>
              <Copy
                className="shrink-0"
                text={longLinkData?.generatedLink || (originalUrl ?? '')}
              />
            </div>
            <div>
              <h3 className="text-2xl font-semibold mb-6">
                Web-Link management
              </h3>
              <div className="text-small break-words break-all whitespace-pre-wrap border border-select p-4 rounded-md">
                {longLinkData?.generatedLink || originalUrl ? (
                  <p>{longLinkData?.generatedLink || (originalUrl ?? '')}</p>
                ) : (
                  <p className="text-secondary">Link not generated yet</p>
                )}
              </div>
            </div>
          </div>
          <ShortLinkGenerator
            agentId={agentId}
            compressed={longLinkData?.compressed as string}
            generatedLink={longLinkData?.generatedLink || ''}
            originalUrl={originalUrl || undefined}
            isMatched={isMatched}
            setIsMatched={setIsMatched}
            shortLinkForm={shortLinkForm}
            agentData={agentData}
            onOpen={onOpen}
            handleDeleteShortLink={data => {
              handleDeleteShortLink(data);
              setLongLinkData(null);
            }}
            handleUpdatehortLink={handleUpdatehortLink}
          />
        </div>

        <LongLinkGenerator
          agentId={agentId}
          onCompress={setLongLinkData}
          originalUrl={originalUrl || ''}
          compressed={longLinkData?.compressed || ''}
        />
      </div>
    </>
  );
};

export default WebLinkGenerator;
